export interface LoadingScreenProps {
  label?: string;
}

/** Full-height placeholder used while a route resolves its data. */
export function LoadingScreen({ label = 'Loading...' }: LoadingScreenProps) {
  return (
    <div className="splash">
      <span className="spinner spinner--large" aria-hidden="true" />
      <p>{label}</p>
    </div>
  );
}

export interface InlineLoaderProps {
  label?: string;
}

export function InlineLoader({ label = 'Loading...' }: InlineLoaderProps) {
  return (
    <div className="row muted">
      <span className="spinner" aria-hidden="true" />
      <span>{label}</span>
    </div>
  );
}
